import { CDP_PUBLIC_URL } from './Constants'
import { getItem, setItem, clearAll, removeItem } from './DataStore'

export const localStorageUtil = {
    set: (key, obj) => {
        localStorage.setItem(key, JSON.stringify(obj))
    },
    get: (key) => ({
        data: JSON.parse(localStorage.getItem(key))
    }),
    remove: (key) => {
        localStorage.removeItem(key)
    }
}

export const sessionUtils = {
    set: (key, obj) => {
        sessionStorage.setItem(key, JSON.stringify(obj))
    },
    get: (key) => ({
        data: JSON.parse(sessionStorage.getItem(key))
    }),
    remove: (key) => {
        sessionStorage.removeItem(key)
    }
}

export const Utils = {
    set: (key, obj) => {
        setItem(key, JSON.stringify(obj))
    },
    get: (key) => ({
        data: JSON.parse(getItem(key))
    }),
    remove: (key) => {
        removeItem(key)
    },
    removeAll: () => {
        clearAll()
    }
}

export const getExitPath = (pathname) => {
    let exitPath
    switch (pathname) {
        case `${CDP_PUBLIC_URL}/recruit`:
        case `${CDP_PUBLIC_URL}/recruit/confirm`:
        case `${CDP_PUBLIC_URL}/recruit/complete`:
            exitPath = 'https://www.metlife.co.jp/recruit/consultant/'
            break
        case `${CDP_PUBLIC_URL}/consulting`:
        case `${CDP_PUBLIC_URL}/consulting/confirm`:
        case `${CDP_PUBLIC_URL}/consulting/complete`:
            exitPath = 'https://www.metlife.co.jp/consulting'
            break
        default:
            exitPath = 'https://www.metlife.co.jp/'
            break
    }
    return exitPath
}

export const loadSatelliteScript = () => {
    const satelliteScript = document.createElement('script')
    satelliteScript.type = 'text/javascript'
    satelliteScript.id = 'satelliteScript'
    const satelliteScriptText = document.createTextNode('_satellite.pageBottom();')
    satelliteScript.appendChild(satelliteScriptText)
    if (document.getElementById('satelliteScript')) {
        document.getElementById('satelliteScript').remove()
    }
    document.body.appendChild(satelliteScript)
}

export const adobeAnalyticsScriptAddition = (pathname) => {
    let pageName = ''
    let channel = ''
    let referrer = ''
    switch (pathname) {
        case `${CDP_PUBLIC_URL}/recruit`:
            pageName = 'CDP_入力'
            channel = 'コンサルタント社員採用'
            referrer = 'CDPフォーム'
            break
        case `${CDP_PUBLIC_URL}/recruit/confirm`:
            pageName = 'CDP_確認'
            channel = 'コンサルタント社員採用'
            referrer = 'CDPフォーム'
            break
        case `${CDP_PUBLIC_URL}/recruit/complete`:
            pageName = 'CDP_完了'
            channel = 'コンサルタント社員採用'
            referrer = 'CDPフォーム'
            break
        case `${CDP_PUBLIC_URL}/pamphlet`:
            pageName = '団体保険お問い合わせ_入力'
            channel = '団体保険お問い合わせ_.co.jp'
            referrer = '団体保険お問い合わせ_入力フォーム'
            break
        case `${CDP_PUBLIC_URL}/pamphlet/confirm`:
            pageName = '団体保険お問い合わせ_確認'
            channel = '団体保険お問い合わせ_.co.jp'
            referrer = '団体保険お問い合わせフォーム'
            break
        case `${CDP_PUBLIC_URL}/pamphlet/complete`:
            pageName = '団体保険お問い合わせ_完了'
            channel = '団体保険お問い合わせ_.co.jp'
            referrer = '団体保険お問い合わせフォーム'
            break
        case `${CDP_PUBLIC_URL}/agency`:
            pageName = '代理店お問い合わせ_入力'
            channel = '代理店お問い合わせ_.co.jp'
            referrer = '代理店お問い合わせ_入力フォーム'
            break
        case `${CDP_PUBLIC_URL}/agency/confirm`:
            pageName = '代理店お問い合わせ_確認'
            channel = '代理店お問い合わせ_.co.jp'
            referrer = '代理店お問い合わせフォーム'
            break
        case `${CDP_PUBLIC_URL}/agency/complete`:
            pageName = '代理店お問い合わせ_完了'
            channel = '代理店お問い合わせ_.co.jp'
            referrer = '代理店お問い合わせフォーム'
            break
        case `${CDP_PUBLIC_URL}/consulting`:
            pageName = 'F2Fフォーム_202411_入力'
            channel = 'sc_F2Fフォーム_202411'
            referrer = 'F2Fフォーム'
            break
        case `${CDP_PUBLIC_URL}/consulting/confirm`:
            pageName = 'F2Fフォーム_202411_確認'
            channel = 'sc_F2Fフォーム_202411'
            referrer = 'F2Fフォーム'
            break
        case `${CDP_PUBLIC_URL}/consulting/complete`:
            pageName = 'F2Fフォーム_202411_完了'
            channel = 'sc_F2Fフォーム_202411'
            referrer = 'F2Fフォーム'
            break
        case `${CDP_PUBLIC_URL}/inquiry`:
            pageName = 'co.jp_お問い合わせ_入力'
            channel = 'お問い合わせ_co.jp'
            referrer = 'お問い合わせフォーム'
            break
        case `${CDP_PUBLIC_URL}/inquiry/confirm`:
            pageName = 'co.jp_お問い合わせ_確認'
            channel = 'お問い合わせ_co.jp'
            referrer = 'お問い合わせフォーム'
            break
        case `${CDP_PUBLIC_URL}/inquiry/complete`:
            pageName = 'co.jp_お問い合わせ_完了'
            channel = 'お問い合わせ_co.jp'
            referrer = 'お問い合わせフォーム'
            break
        default:
            break
    }
    const script = document.createElement('script')
    script.type = 'text/javascript'
    script.id = 'adobeAnalyticsScript'
    const scriptText = document.createTextNode('var digitalData = {' + '\n' +
        'page: {' + '\n' +
        'pageName: "' + pageName + '",' + '\n' +
        'channel: "' + channel + '",' + '\n' +
        'referrer: "' + referrer + '",' + '\n' +
        '}' + '\n' +
        '};')
    script.appendChild(scriptText)
    if (document.getElementById('adobeAnalyticsScript')) {
        document.getElementById('adobeAnalyticsScript').remove()
    }
    document.body.appendChild(script)
}

export const cssAddition = (pathname) => {
    switch (pathname) {
        case `${CDP_PUBLIC_URL}/consulting`:
        case `${CDP_PUBLIC_URL}/consulting/confirm`:
        case `${CDP_PUBLIC_URL}/consulting/complete`:
            cssInject('/forms/css/ConsultationHeaderFooter.css')
            cssInject('/forms/css/ConsultationForm.css')
            break
        default:
            break
    }
}

export const hostValue = (url) => {
    const urlRe = ''
    const index = url.indexOf(urlRe)
    const result = url.slice(index + (urlRe.length))
    const splitParam = result.split('?')
    const tempSplitValue = splitParam[0].split('/forms/')
    const splitValue = tempSplitValue[0]
    return splitValue
}

const cssInject = (cssPath) => {
    const findLocation = window.location.href
    const path = (hostValue(findLocation) + cssPath)
    const linkToAdd = document.createElement('link')
    linkToAdd.rel = 'stylesheet'
    linkToAdd.href = path
    return document.head.appendChild(linkToAdd)
}
